/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
};

export type CharacterData = {
  __typename?: 'CharacterData';
  ascensionBossMaterial?: Maybe<Scalars['String']['output']>;
  ascensionBossMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  ascensionStat?: Maybe<Stat>;
  birthday?: Maybe<Scalars['Date']['output']>;
  characterCorrectImageUrl?: Maybe<Scalars['String']['output']>;
  characterId?: Maybe<Scalars['ID']['output']>;
  characterImageUrl?: Maybe<Scalars['String']['output']>;
  characterName?: Maybe<Scalars['String']['output']>;
  characterWrongImageUrl?: Maybe<Scalars['String']['output']>;
  constellations?: Maybe<Array<ConstellationData>>;
  element?: Maybe<GenshinElement>;
  enhancementMaterial?: Maybe<Scalars['String']['output']>;
  enhancementMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Height>;
  localSpecialty?: Maybe<Scalars['String']['output']>;
  localSpecialtyImageUrl?: Maybe<Scalars['String']['output']>;
  rarity?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Region>;
  talentBook?: Maybe<Array<Scalars['String']['output']>>;
  talentBookImageUrl?: Maybe<Array<Scalars['String']['output']>>;
  talentBossMaterial?: Maybe<Scalars['String']['output']>;
  talentBossMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  talents?: Maybe<Array<TalentData>>;
  weaponType?: Maybe<WeaponType>;
};

export type CharacterSearchFilter = {
  characterName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConstellationData = {
  __typename?: 'ConstellationData';
  characterImageUrl?: Maybe<Scalars['String']['output']>;
  characterName?: Maybe<Scalars['String']['output']>;
  constellationId?: Maybe<Scalars['ID']['output']>;
  constellationImageUrl?: Maybe<Scalars['String']['output']>;
  constellationLevel?: Maybe<Scalars['Int']['output']>;
  constellationName?: Maybe<Scalars['String']['output']>;
};

export type ConstellationSearchFilter = {
  characterName?: InputMaybe<Scalars['String']['input']>;
  constellationName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DailyRecordData = {
  __typename?: 'DailyRecordData';
  character: CharacterData;
  characterSolved: Scalars['Int']['output'];
  constellation: ConstellationData;
  constellationSolved: Scalars['Int']['output'];
  dailyRecordId: Scalars['ID']['output'];
  food: FoodData;
  foodSolved: Scalars['Int']['output'];
  talent: TalentData;
  talentSolved: Scalars['Int']['output'];
  weapon: WeaponData;
  weaponSolved: Scalars['Int']['output'];
};

export type FoodData = {
  __typename?: 'FoodData';
  event?: Maybe<Scalars['Boolean']['output']>;
  foodId?: Maybe<Scalars['ID']['output']>;
  foodImageUrl?: Maybe<Scalars['String']['output']>;
  foodName?: Maybe<Scalars['String']['output']>;
  foodType?: Maybe<FoodType>;
  purchasable?: Maybe<Scalars['Boolean']['output']>;
  rarity?: Maybe<Scalars['Int']['output']>;
  recipe?: Maybe<Scalars['Boolean']['output']>;
  specialDish?: Maybe<Scalars['Boolean']['output']>;
};

export type FoodSearchFilter = {
  foodName?: InputMaybe<Scalars['String']['input']>;
  foodType?: InputMaybe<FoodType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FoodType {
  AtkBoostingDishes = 'ATK_Boosting_Dishes',
  AdventurersDishes = 'Adventurers_Dishes',
  DefBoostingDishes = 'DEF_Boosting_Dishes',
  EssentialOils = 'Essential_Oils',
  OtherDishes = 'Other_Dishes',
  Potions = 'Potions',
  RecoveryDishes = 'Recovery_Dishes'
}

export enum GameDataType {
  Character = 'Character',
  Constellation = 'Constellation',
  Food = 'Food',
  Talent = 'Talent',
  Weapon = 'Weapon'
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

export enum GenshinElement {
  Anemo = 'Anemo',
  Cryo = 'Cryo',
  Dendro = 'Dendro',
  Electro = 'Electro',
  Geo = 'Geo',
  Hydro = 'Hydro',
  Pyro = 'Pyro'
}

export enum Height {
  Medium = 'Medium',
  Short = 'Short',
  Tall = 'Tall'
}

export type LocalSpecialtyData = {
  __typename?: 'LocalSpecialtyData';
  imageUrl: Scalars['String']['output'];
  localSpecialty: Scalars['String']['output'];
  region: Region;
};

export type Mutation = {
  __typename?: 'Mutation';
  updateDailyRecord: Scalars['String']['output'];
};


export type MutationUpdateDailyRecordArgs = {
  id: Scalars['ID']['input'];
  type: GameDataType;
};

export type Query = {
  __typename?: 'Query';
  characterData: Array<CharacterData>;
  constellationData: Array<ConstellationData>;
  dailyRecordData: DailyRecordData;
  foodData: Array<FoodData>;
  localSpecialtyData: Array<LocalSpecialtyData>;
  regionData: Array<RegionData>;
  talentData: Array<TalentData>;
  weaponData: Array<WeaponData>;
};


export type QueryCharacterDataArgs = {
  filter?: InputMaybe<CharacterSearchFilter>;
};


export type QueryConstellationDataArgs = {
  filter?: InputMaybe<ConstellationSearchFilter>;
};


export type QueryFoodDataArgs = {
  filter?: InputMaybe<FoodSearchFilter>;
};


export type QueryTalentDataArgs = {
  filter?: InputMaybe<TalentSearchFilter>;
};


export type QueryWeaponDataArgs = {
  filter?: InputMaybe<WeaponSearchFilter>;
};

export enum Region {
  Fontaine = 'Fontaine',
  Inazuma = 'Inazuma',
  Liyue = 'Liyue',
  Mondstadt = 'Mondstadt',
  Natlan = 'Natlan',
  Snezhnaya = 'Snezhnaya',
  Sumeru = 'Sumeru'
}

export type RegionData = {
  __typename?: 'RegionData';
  id: Scalars['ID']['output'];
  name: Region;
};

export enum Stat {
  Atk = 'ATK',
  AnemoDmgBonus = 'Anemo_DMG_Bonus',
  CritDmg = 'CRIT_DMG',
  CritRate = 'CRIT_Rate',
  CryoDmgBonus = 'Cryo_DMG_Bonus',
  Def = 'DEF',
  DendroDmgBonus = 'Dendro_DMG_Bonus',
  ElectroDmgBonus = 'Electro_DMG_Bonus',
  ElementalMastery = 'Elemental_Mastery',
  EnergyRecharge = 'Energy_Recharge',
  GeoDmgBonus = 'Geo_DMG_Bonus',
  Hp = 'HP',
  HealingBonus = 'Healing_Bonus',
  HydroDmgBonus = 'Hydro_DMG_Bonus',
  PhysicalDmgBonus = 'Physical_DMG_Bonus',
  PyroDmgBonus = 'Pyro_DMG_Bonus'
}

export type Subscription = {
  __typename?: 'Subscription';
  dailyRecordUpdated: UpdatedSolvedValue;
};

export type TalentData = {
  __typename?: 'TalentData';
  characterImageUrl?: Maybe<Scalars['String']['output']>;
  characterName?: Maybe<Scalars['String']['output']>;
  talentId?: Maybe<Scalars['ID']['output']>;
  talentImageUrl?: Maybe<Scalars['String']['output']>;
  talentName?: Maybe<Scalars['String']['output']>;
  talentType?: Maybe<TalentType>;
};

export type TalentSearchFilter = {
  characterName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  talentName?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentType {
  AlternateSprint = 'Alternate_Sprint',
  ElementalBurst = 'Elemental_Burst',
  ElementalSkill = 'Elemental_Skill',
  FirstAscensionPassive = 'First_Ascension_Passive',
  FourthAscensionPassive = 'Fourth_Ascension_Passive',
  NightRealmsGiftPassive = 'Night_Realms_Gift_Passive',
  NormalAttack = 'Normal_Attack',
  Passive = 'Passive',
  UtilityPassive = 'Utility_Passive'
}

export type UpdatedSolvedValue = {
  __typename?: 'UpdatedSolvedValue';
  newSolvedValue: Scalars['Int']['output'];
  type: GameDataType;
};

export type WeaponData = {
  __typename?: 'WeaponData';
  commonEnemyMaterial?: Maybe<Scalars['String']['output']>;
  commonEnemyMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  eliteEnemyMaterial?: Maybe<Scalars['String']['output']>;
  eliteEnemyMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  gacha?: Maybe<Scalars['Boolean']['output']>;
  rarity?: Maybe<Scalars['Int']['output']>;
  subStat?: Maybe<Stat>;
  weaponDomainMaterial?: Maybe<Scalars['String']['output']>;
  weaponDomainMaterialImageUrl?: Maybe<Scalars['String']['output']>;
  weaponId?: Maybe<Scalars['ID']['output']>;
  weaponImageUrl?: Maybe<Scalars['String']['output']>;
  weaponName?: Maybe<Scalars['String']['output']>;
  weaponType?: Maybe<WeaponType>;
};

export type WeaponSearchFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  weaponName?: InputMaybe<Scalars['String']['input']>;
  weaponType?: InputMaybe<WeaponType>;
};

export enum WeaponType {
  Bow = 'Bow',
  Catalyst = 'Catalyst',
  Claymore = 'Claymore',
  Polearm = 'Polearm',
  Sword = 'Sword'
}

export type UpdateDailyRecordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type: GameDataType;
}>;


export type UpdateDailyRecordMutation = { __typename?: 'Mutation', updateDailyRecord: string };

export type GetTeyvatdleApiDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeyvatdleApiDataQuery = { __typename?: 'Query', dailyRecordData: { __typename?: 'DailyRecordData', dailyRecordId: string, characterSolved: number, weaponSolved: number, talentSolved: number, constellationSolved: number, foodSolved: number, character: { __typename?: 'CharacterData', characterId?: string | null, characterName?: string | null, gender?: Gender | null, height?: Height | null, rarity?: number | null, region?: Region | null, element?: GenshinElement | null, weaponType?: WeaponType | null, ascensionStat?: Stat | null, birthday?: any | null, characterImageUrl?: string | null, characterCorrectImageUrl?: string | null, characterWrongImageUrl?: string | null, localSpecialty?: string | null, localSpecialtyImageUrl?: string | null, enhancementMaterial?: string | null, enhancementMaterialImageUrl?: string | null, ascensionBossMaterial?: string | null, ascensionBossMaterialImageUrl?: string | null, talentBossMaterial?: string | null, talentBossMaterialImageUrl?: string | null, talentBook?: Array<string> | null, talentBookImageUrl?: Array<string> | null }, weapon: { __typename?: 'WeaponData', weaponId?: string | null, weaponName?: string | null, rarity?: number | null, weaponType?: WeaponType | null, subStat?: Stat | null, weaponImageUrl?: string | null, weaponDomainMaterial?: string | null, weaponDomainMaterialImageUrl?: string | null, eliteEnemyMaterial?: string | null, eliteEnemyMaterialImageUrl?: string | null, commonEnemyMaterial?: string | null, commonEnemyMaterialImageUrl?: string | null, gacha?: boolean | null }, talent: { __typename?: 'TalentData', talentId?: string | null, talentName?: string | null, talentType?: TalentType | null, talentImageUrl?: string | null, characterName?: string | null }, constellation: { __typename?: 'ConstellationData', constellationId?: string | null, constellationName?: string | null, constellationLevel?: number | null, constellationImageUrl?: string | null, characterName?: string | null }, food: { __typename?: 'FoodData', foodId?: string | null, foodName?: string | null, rarity?: number | null, foodType?: FoodType | null, specialDish?: boolean | null, purchasable?: boolean | null, recipe?: boolean | null, event?: boolean | null, foodImageUrl?: string | null } }, characterData: Array<{ __typename?: 'CharacterData', characterId?: string | null, characterName?: string | null, gender?: Gender | null, height?: Height | null, rarity?: number | null, region?: Region | null, element?: GenshinElement | null, weaponType?: WeaponType | null, ascensionStat?: Stat | null, birthday?: any | null, characterImageUrl?: string | null, characterCorrectImageUrl?: string | null, characterWrongImageUrl?: string | null, localSpecialty?: string | null, localSpecialtyImageUrl?: string | null, enhancementMaterial?: string | null, enhancementMaterialImageUrl?: string | null, ascensionBossMaterial?: string | null, ascensionBossMaterialImageUrl?: string | null, talentBossMaterial?: string | null, talentBossMaterialImageUrl?: string | null, talentBook?: Array<string> | null, talentBookImageUrl?: Array<string> | null }>, foodData: Array<{ __typename?: 'FoodData', foodId?: string | null, foodName?: string | null, rarity?: number | null, foodType?: FoodType | null, specialDish?: boolean | null, purchasable?: boolean | null, recipe?: boolean | null, event?: boolean | null, foodImageUrl?: string | null }>, weaponData: Array<{ __typename?: 'WeaponData', weaponId?: string | null, weaponName?: string | null, rarity?: number | null, weaponType?: WeaponType | null, subStat?: Stat | null, weaponImageUrl?: string | null, weaponDomainMaterial?: string | null, weaponDomainMaterialImageUrl?: string | null, eliteEnemyMaterial?: string | null, eliteEnemyMaterialImageUrl?: string | null, commonEnemyMaterial?: string | null, commonEnemyMaterialImageUrl?: string | null, gacha?: boolean | null }> };

export type ListenForDailyRecordUpdatesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ListenForDailyRecordUpdatesSubscription = { __typename?: 'Subscription', dailyRecordUpdated: { __typename?: 'UpdatedSolvedValue', type: GameDataType, newSolvedValue: number } };


export const UpdateDailyRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDailyRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GameDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDailyRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}]}}]} as unknown as DocumentNode<UpdateDailyRecordMutation, UpdateDailyRecordMutationVariables>;
export const GetTeyvatdleApiDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeyvatdleAPIData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyRecordData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyRecordId"}},{"kind":"Field","name":{"kind":"Name","value":"characterSolved"}},{"kind":"Field","name":{"kind":"Name","value":"weaponSolved"}},{"kind":"Field","name":{"kind":"Name","value":"talentSolved"}},{"kind":"Field","name":{"kind":"Name","value":"constellationSolved"}},{"kind":"Field","name":{"kind":"Name","value":"foodSolved"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"characterId"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"element"}},{"kind":"Field","name":{"kind":"Name","value":"weaponType"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionStat"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"characterImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterCorrectImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterWrongImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"localSpecialty"}},{"kind":"Field","name":{"kind":"Name","value":"localSpecialtyImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"enhancementMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"enhancementMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionBossMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionBossMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"talentBossMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"talentBossMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"talentBook"}},{"kind":"Field","name":{"kind":"Name","value":"talentBookImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weapon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weaponId"}},{"kind":"Field","name":{"kind":"Name","value":"weaponName"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"weaponType"}},{"kind":"Field","name":{"kind":"Name","value":"subStat"}},{"kind":"Field","name":{"kind":"Name","value":"weaponImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"weaponDomainMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"weaponDomainMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eliteEnemyMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"eliteEnemyMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"commonEnemyMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"commonEnemyMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"gacha"}}]}},{"kind":"Field","name":{"kind":"Name","value":"talent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"talentId"}},{"kind":"Field","name":{"kind":"Name","value":"talentName"}},{"kind":"Field","name":{"kind":"Name","value":"talentType"}},{"kind":"Field","name":{"kind":"Name","value":"talentImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constellationId"}},{"kind":"Field","name":{"kind":"Name","value":"constellationName"}},{"kind":"Field","name":{"kind":"Name","value":"constellationLevel"}},{"kind":"Field","name":{"kind":"Name","value":"constellationImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"food"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodId"}},{"kind":"Field","name":{"kind":"Name","value":"foodName"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"foodType"}},{"kind":"Field","name":{"kind":"Name","value":"specialDish"}},{"kind":"Field","name":{"kind":"Name","value":"purchasable"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"foodImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"characterData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"characterId"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"element"}},{"kind":"Field","name":{"kind":"Name","value":"weaponType"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionStat"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"characterImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterCorrectImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"characterWrongImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"localSpecialty"}},{"kind":"Field","name":{"kind":"Name","value":"localSpecialtyImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"enhancementMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"enhancementMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionBossMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"ascensionBossMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"talentBossMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"talentBossMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"talentBook"}},{"kind":"Field","name":{"kind":"Name","value":"talentBookImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"foodData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodId"}},{"kind":"Field","name":{"kind":"Name","value":"foodName"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"foodType"}},{"kind":"Field","name":{"kind":"Name","value":"specialDish"}},{"kind":"Field","name":{"kind":"Name","value":"purchasable"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"foodImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weaponData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weaponId"}},{"kind":"Field","name":{"kind":"Name","value":"weaponName"}},{"kind":"Field","name":{"kind":"Name","value":"rarity"}},{"kind":"Field","name":{"kind":"Name","value":"weaponType"}},{"kind":"Field","name":{"kind":"Name","value":"subStat"}},{"kind":"Field","name":{"kind":"Name","value":"weaponImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"weaponDomainMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"weaponDomainMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eliteEnemyMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"eliteEnemyMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"commonEnemyMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"commonEnemyMaterialImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"gacha"}}]}}]}}]} as unknown as DocumentNode<GetTeyvatdleApiDataQuery, GetTeyvatdleApiDataQueryVariables>;
export const ListenForDailyRecordUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ListenForDailyRecordUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyRecordUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"newSolvedValue"}}]}}]}}]} as unknown as DocumentNode<ListenForDailyRecordUpdatesSubscription, ListenForDailyRecordUpdatesSubscriptionVariables>;